import { updateDetail, getPrevDetailX, getPrevDetailY } from "./preview";

let googleFonts = document.getElementById("googleFonts");
// ui, fantasy2, eorzean2, future1, future2
let gFonts = ['PT+Sans', 'Sawarabi+Mincho', 'Unna', 'Unna', 'Plaster', 'Miriam+Libre'];

loadGFont();

//takes an array of values to be concated onto the gfonts array
//custom is for font classes, might need to be edited to just directly edit style rules
export function loadGFont(fonturlArray, custom) {
    if (fonturlArray != undefined) {
        fonturlArray.forEach((font) => {
            if (font != '') {
                gFonts.push(font.trim().replaceAll(' ', '+'));
            }
        });
    }

    let urlString = '';
    gFonts.forEach((font, i) => {
        urlString += 'family=' + font + '&';
    });
    // edit load url
    googleFonts.innerHTML = "@import url('https://fonts.googleapis.com/css2?" + urlString + "display=swap');";

    // generate style rules
    if (custom == true) {
        let fontFamily = [];
        fonturlArray.forEach((font, i) => {
            fontFamily.push("'" + font.replaceAll('+',' ') + "'");
        });
        fontSelect[fontSelect.length-1] = fontFamily;
        console.log(fontSelect[fontSelect.length-1]);
        updateDetail(getPrevDetailX(),getPrevDetailY());
    }
}

// value to fonts pairs
let fontSelect = [
    //fantasy
    ["'fantasy1','Sawarabi Mincho'", "'Unna',serif"],
    //eorzean
    ["'eorzean1','Sawarabi Mincho'", "'Unna',serif"],
    //future
    ["'Plaster', 'future1JP'", "'Miriam Libre',sans-serif"],
    //serif
    ["Sawarabi Mincho", "serif"],
    //sansserif
    ["sans-serif", "sans-serif"],
    //custom placeholder
    ["'fantasy1','Sawarabi Mincho'", "'Unna',serif"]
];

//add processed font names to this array in order to add font-family to rules to use imported fonts
//do NOT try to load fonts here, for the sake of my sanity font loading and listing/selection is seperate

export function selectFont(family, face) { 
    return fontSelect[family][face];
};

export function selectCustomFont(face) {
    return selectFont(fontSelect.length - 1, face);
};
